import React from 'react';
import BannerSlider from '../BannerSlider';
import LoanSection from '../LoanSection';
import NeoLoanCards from '../NeoLoanCards';
import VideoCarousel from '../VideoCarousel';
import MortgageTools from '../MortgageTools';
import AboutMortbuzz from '../AboutMortbuzz';
import Partner from '../components/Partner';
import FaqSection from '../components/FaqSection';
import Seo from "../components/Seo";




const Home = () => {
  return (
    <>
     <Seo
        title="Mortbuzz - Best Home Loan & Financial Services in Pune"
        description="Mortbuzz offers the best home loans, personal loans, and mortgage solutions in Pune. Compare interest rates & get instant loan approvals."
        keywords="home loan Pune, personal loan Pune, mortgage services Pune, loan consultant Pune, best loan agency Pune, LAP, car loan, business loan"
        canonical="https://www.mortbuzz.in/"
      />




<BannerSlider /> {/* ✅ Top slider */}

      <LoanSection
        bgImage="https://mortbuzz.in/wp-content/uploads/2025/04/wp2406649-luxury-house-wallpapers-scaled.jpg"
        heading="Home Loans Starting At"
        highlight="7.35%*"
        features={[
          "Upto 100% Cashback On All Bank Charges",
          "Loan from Public Sector Only",
          "Flexible EMI Options Tailored to Your Needs",
          "Guaranteed low interest home loan in Pune",
          "Zero Processing Fees on Selected Banks",
          "Doorstep Services",
          "Loan Agents In Pune"
        ]}
        imgSrc="https://mortbuzz.in/wp-content/uploads/2025/04/1-1.png"
      />
      <NeoLoanCards />
      
    <VideoCarousel/>
    <MortgageTools/>
    <AboutMortbuzz/>
    <Partner/>
    <FaqSection />



    </>
  );
};

export default Home;